import React, { FC, ReactElement, InputHTMLAttributes, ChangeEvent } from 'react'
import classNames from 'classnames'
import {Icon} from "../Icon/Icon";

type InputSize = 'lg' | 'sm'
export interface InputProps extends Omit<InputHTMLAttributes<HTMLElement>, 'size' > {
  disabled?: boolean;
  size?: InputSize;
  icon?: string;
  /**添加前缀 用于配置一些固定组合 */
  prepend?: string | ReactElement;
  /**添加后缀 用于配置一些固定组合 */
  append?: string | ReactElement;
  onChange? : (e: ChangeEvent<HTMLInputElement>) => void;
}


export const Input: FC<InputProps> = (props) => {
  const {disabled, size, icon, prepend, append, style, ...restProps} = props
  const inputClasses = classNames('ting-input-wrapper', {
    [`input-size-${size}`]: size,
    'is-disabled': disabled,
    'input-group': prepend || append,
    'input-group-append': !!append,
    'input-group-prepend': !!prepend
  })
  const fixControlledValue = (value: any) => {
    if (typeof value === 'undefined' || value === null) {
      return ''
    }
    return value
  }
  if('value' in props) {
    delete restProps.defaultValue
    restProps.value = fixControlledValue(props.value)
  }
  return (
    <div className={inputClasses} style={style}>
      {prepend && <div className="ting-input-group-prepend">{prepend}</div>}
      {icon && <div className="icon-wrapper"><Icon name={icon}/></div>}
      <input
        className="ting-input-inner"
        disabled={disabled}
        {...restProps}
      />
      {append && <div className="ting-input-group-append">{append}</div>}
    </div>
  )
}

export default Input;